import React from 'react';
import './Spacer.css';

const Spacer = () => {
  return <div className="spacer"></div>;
};

export default Spacer;